/** Customer */
import CustomerDetailPage from 'domains/customer/pages/detail-page'
/** Customer Address */
import CustomerAddressCreatePage from 'domains/customer/pages/address-create-page'
import CustomerAddressEditPage from 'domains/customer/pages/address-edit-page'


/** Customer Order */
import {
  CustomerOrderDetailPage,
  CustomerOrderShipmentDetailPage,
  CustomerOrderShipmentAddressEditPage,
  CustomerOrderNewShipmentPage
} from 'domains/customer-order'

const shared_routes = [
  /** Customer */
  {
    path      : '/customers/:id',
    name      : 'Customer Detail',
    component : CustomerDetailPage,
    layout    : '/app',
    invisible : true
  },
  {
    path      : '/customers/:customer_id/addresses/create',
    name      : 'Customer Address Create',
    component : CustomerAddressCreatePage,
    layout    : '/app',
    invisible : true
  },
  {
    path      : '/customer-addresses/:address_id/edit',
    name      : 'Edit Customer Address',
    component : CustomerAddressEditPage,
    layout    : '/app',
    invisible : true
  },

  /** Customer::Order */
  {
    path      : '/customer-orders/:id',
    name      : 'Order Detail',
    component : CustomerOrderDetailPage,
    layout    : '/app',
    invisible : true
  },
  {
    path      : '/customer-orders/:id/new-shipment',
    name      : 'Order Create',
    component : CustomerOrderNewShipmentPage,
    layout    : '/app',
    invisible : true
  },
  /** Customer::Shipment */
  {
    path      : '/customer-shipments/:id',
    name      : 'Shipment Detail',
    component : CustomerOrderShipmentDetailPage,
    layout    : '/app',
    invisible : true
  },
  {
    path      : '/customer-shipments/:id/edit-address',
    name      : 'Edit Shipment Address',
    component : CustomerOrderShipmentAddressEditPage,
    layout    : '/app',
    invisible : true
  }
]

export default shared_routes